import {
  ButtonERP,
  CalendarPrimeReact,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { faFileExport } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import notification from "common/utils/notification"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export interface DateRangeModalFechas {
  min?: Date
  max?: Date
}

export const ModalFechas = ({
  isOpen = false,
  date,
  setDate,
  onConfirm,
  onCancel,
  text,
}: {
  isOpen: boolean
  date: DateRangeModalFechas
  setDate: React.Dispatch<React.SetStateAction<DateRangeModalFechas>>
  onConfirm: () => void
  onCancel: () => void
  text: string | React.ReactNode
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const {
    t,
    i18n: { language },
  } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      focusOnShow={false}
      header={t("diario.exportModal.title")}
      footer={
        <div
          key='Actions'
          className='tw-flex tw-flex-row tw-justify-end tw-pb-1 tw-gap-3'
        >
          <ButtonERP
            label={`${t("diario.exportModal.cancel")}`}
            customize={{
              type: "white",
              size: "md",
            }}
            onClick={onCancel}
          />
          <ButtonERP
            label={
              !isLoading
                ? `${t("diario.exportModal.export")}`
                : `${t("diario.exportModal.isExport")}`
            }
            loading={isLoading}
            icon={<FontAwesomeIcon icon={faFileExport} />}
            customize={{
              type: "primary",
              size: "md",
            }}
            onClick={async () => {
              setIsLoading(true)
              try {
                await onConfirm()
                notification.success({
                  body: `${t("notification.excelDownloadSuccess")}`,
                })
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Error al ejecutar onConfirm:", error)
              } finally {
                setIsLoading(false)
                onCancel()
              }
            }}
          />
        </div>
      }
    >
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-text-center'>
        <p className='tw-text-left tw-mb-4'>{text}</p>

        <div className='tw-flex tw-flex-col mobile:tw-flex-row tw-mb-6 tw-text-left'>
          <div className='tw-flex tw-flex-col tw-flex-grow tw-mb-4 mobile:tw-mb-0'>
            <label className='tw-mb-2'>
              {t("diario.exportModal.startDate")}
            </label>
            <CalendarPrimeReact
              id='fechaDesde'
              name='fechaDesde'
              clearButtonClassName='!tw-hidden'
              readOnlyInput
              value={date?.min ? new Date(date.min) : undefined}
              locale={language}
              onChange={(e) => {
                const eventDate = e.target.value as unknown as Date
                setDate({
                  max: date?.max,
                  min: eventDate,
                })
              }}
              placeholder='dd/mm/aaaa'
              dateFormat='dd/mm/yy'
              showIcon
              maxDate={date?.max ? new Date(date.max) : undefined}
            />
          </div>
          <div className='tw-hidden mobile:tw-block tw-py-3 tw-px-3 tw-items-baseline tw-mt-auto tw-mb-0'>
            -
          </div>
          <div className='tw-flex tw-flex-col tw-flex-grow'>
            <label>{t("diario.exportModal.endDate")}</label>
            <CalendarPrimeReact
              id='fechaHasta'
              name='fechaHasta'
              readOnlyInput
              value={date?.max ? new Date(date.max) : undefined}
              locale={language}
              onChange={(e) => {
                const eventDate = e.target.value as unknown as Date
                setDate({
                  min: date?.min,
                  max: eventDate,
                })
              }}
              placeholder='dd/mm/aaaa'
              dateFormat='dd/mm/yy'
              className='tw-w-full'
              showIcon
              minDate={date?.min ? new Date(date.min) : undefined}
            />
          </div>
        </div>
      </div>
    </PrimeReactModal>
  )
}
